import { render } from "./ui-schedule.vue?vue&type=template&id=6d9e858f&ts=true"
import script from "./ui-schedule.vue?vue&type=script&lang=ts"
export * from "./ui-schedule.vue?vue&type=script&lang=ts"

import "./ui-schedule.vue?vue&type=style&index=0&id=6d9e858f&lang=less"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__